import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as organisationAdminActions from '../../ducks/organisation-admin'
import UsageLog from '../UsageLog'

class OrganisationUsageLogContainer extends React.Component {
  componentWillUnmount() {
    this.props.actions.fetchUsageSummary()
  }

  render() {
    const fetchUsageSummary = (year, month) =>
      this.props.actions.fetchUsageSummary(
        this.props.currentOrganisation.organisation.id,
        year,
        month
      )

    return (
      <UsageLog
        usageLog={this.props.usageLog}
        onSummarize={fetchUsageSummary}
        isSuperAdminView={false}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    currentOrganisation: state.account.get('currentOrganisation'),
    usageLog: state.organisationAdmin.get('usageLog')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(organisationAdminActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationUsageLogContainer)



// WEBPACK FOOTER //
// ./src/components/smart/OrganisationUsageLogContainer.js